/* ============================================================
   Flooring Fitted — Instant Quote Widget
   Drives the inline quote card in the home hero.
   Reads fitted/supply prices from <option data-fitted> data-attrs.
   ============================================================ */
(function () {
  const root = document.querySelector('[data-quote-widget]');
  if (!root) return;

  const $ = (sel) => root.querySelector(sel);
  const type    = $('[data-quote-type]');
  const length  = $('[data-quote-length]');
  const width   = $('[data-quote-width]');
  const btn     = $('[data-quote-calc]');

  const m2Out       = $('[data-quote-m2]');
  const materialOut = $('[data-quote-materials]');
  const fittingOut  = $('[data-quote-fitting]');
  const totalOut    = $('[data-quote-total]');

  const money = (n) => '£' + Math.round(n).toLocaleString('en-GB');

  function calc() {
    const opt     = type.options[type.selectedIndex];
    const supply  = parseFloat(opt?.dataset.supply)  || 19.99;
    const fitted  = parseFloat(opt?.dataset.fitted)  || 34.99;
    const l = parseFloat(length.value) || 0;
    const w = parseFloat(width.value)  || 0;

    // Raw L×W per the design — the survey firms the figure up (no wastage here)
    const m2 = +(l * w).toFixed(2);
    const materials = m2 * supply;
    const fitting   = m2 * (fitted - supply); // fitting ≈ difference between fitted & supply
    const total     = m2 * fitted;

    m2Out.textContent       = m2.toFixed(2);
    materialOut.textContent = money(materials);
    fittingOut.textContent  = money(fitting);
    totalOut.textContent    = money(total);
  }

  btn.addEventListener('click', calc);
  [type, length, width].forEach(el => el.addEventListener('input', calc));

  calc(); // initial
})();
